import { useAuthentication } from "@/Slices/authenticationSlice";

/**
 * Shared accessor for the current auth flag. Lives outside `Features/` so
 * feature code can read authentication state without a cross-feature import
 * into the Authentication slice.
 */
export function useIsAuthenticated(): boolean {
  return useAuthentication().isAuthenticated;
}
